import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highcharts3d from "highcharts/highcharts-3d";
import HC_exporting from "highcharts/modules/exporting";
import highchartsMap from "highcharts/modules/map";
import { Spinner } from "react-bootstrap";

highcharts3d(Highcharts);
HC_exporting(Highcharts);
highchartsMap(Highcharts);

const ChartContainer: React.FC<{
  colSize: string;
  cardTitleLarge?: string;
  cardTitleSmall?: string;
  children: any;
}> = ({ colSize = "12", cardTitleLarge, cardTitleSmall, children }) => {
  return (
    <div className={`col-${colSize}`}>
      <div className="card">
        <div className="card-body">
          {
            cardTitleLarge || cardTitleSmall ? 
            <h5 className="card-title">
              {cardTitleLarge ? cardTitleLarge : null} {cardTitleSmall && <span>/ {cardTitleSmall}</span>}
            </h5> : null
          }          
          {children}
        </div>
      </div>
    </div>
  );
};

export const ChartContainerLoader: React.FC<{
  colSize: string;
}> = ({ colSize = "12" }) => {
  return (
    <div className={`col-${colSize}`}>
      <div className="card" style={{ height: "31rem" }}>
        <div className="card-body d-flex justify-content-center align-items-center">
          <Spinner />
        </div>
      </div>
    </div>
  );
};

export const HighChart: React.FC<{
  colSize: string;
  cardTitleLarge?: string;
  cardTitleSmall?: string;
  options: any;
}> = ({ cardTitleLarge, cardTitleSmall, colSize, options }) => {
  if (!options) {
    return null;
  }
  return (
    <ChartContainer
      cardTitleLarge={cardTitleLarge}
      cardTitleSmall={cardTitleSmall}
      colSize={colSize}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        // containerProps={{ style: { width: chartWidth } }}
      />
    </ChartContainer>
  );
};

export const AdditionalChart: React.FC<{
  colSize: string;
  cardTitleLarge: string;
  cardTitleSmall: string;
  children: any;
}> = ({ cardTitleLarge, cardTitleSmall, colSize, children }) => {
  return (
    <ChartContainer
      cardTitleLarge={cardTitleLarge}
      cardTitleSmall={cardTitleSmall}
      colSize={colSize}
    >
      {children}
    </ChartContainer>
  );
};
